/**
 * Constantes de rota compartilhadas.
 *
 * DEFAULT_PATH e a rota inicial pos-login. Aponta para /visao-geral, que e
 * acessivel a QUALQUER usuario autenticado (ProtectedPage sem `requires`) —
 * ao contrario de /home, que exige a permissao `dashboard:view`. Manter aqui
 * (e nao em App.jsx) permite que as telas de Auth importem sem criar ciclo de
 * importacao com App.jsx.
 */
import { MODULO_PLANILHA_LEGADO } from "../config/modulos";

export const DEFAULT_PATH = "/visao-geral";

/**
 * Destino do "Início" (logo do cabeçalho e casinha do breadcrumb). O /home é a
 * tela inicial do Legado, que lê a planilha do Gerenciador: sem esse módulo
 * contratado (ADR-0102) o Início é o destino padrão.
 */
export function rotaDeInicio(temModulo) {
  return typeof temModulo === "function" && temModulo(MODULO_PLANILHA_LEGADO) ? "/home" : DEFAULT_PATH;
}
